import { CrudService } from "./crud.service";
import { CrudAction } from "../../helpers/enums";
import {
  Directive,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  OnDestroy
} from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";

export class CrudBase implements OnDestroy {
  private _track: Subscription;

  protected state: number;
  @Output() crudClick = new EventEmitter();

  constructor(
    public element: ElementRef,
    public crudService: CrudService,
    protected action: CrudAction
  ) {
    this._track = crudService.crudStateTracker.subscribe(state => {
      this.setState(state);
    });
    this.setState(crudService.CRUD);
  }

  ngOnDestroy() {
    this._track.unsubscribe();
  }

  @HostListener("click", ["$event"])
  onClick(e) {
    if (!this.crudService.canExecute(this.action)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    this.crudClick.next(e);
  }

  protected setState(value: number) {
    this.state = value;
    this.element.nativeElement.disabled = !this.crudService.canExecute(
      this.action
    );
  }
}

@Directive({
  selector: "[crud-create]"
})
export class CrudCreate extends CrudBase implements OnDestroy {
  constructor(public element: ElementRef, public crudService: CrudService) {
    super(element, crudService, CrudAction.Create);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}

@Directive({
  selector: "[crud-read]"
})
export class CrudRead extends CrudBase implements OnDestroy {
  constructor(public element: ElementRef, public crudService: CrudService) {
    super(element, crudService, CrudAction.Read);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}

@Directive({
  selector: "[crud-update]"
})
export class CrudUpdate extends CrudBase implements OnDestroy {
  constructor(public element: ElementRef, public crudService: CrudService) {
    super(element, crudService, CrudAction.Update);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}

@Directive({
  selector: "[crud-delete]"
})
export class CrudDelete extends CrudBase implements OnDestroy {
  constructor(public element: ElementRef, public crudService: CrudService) {
    super(element, crudService, CrudAction.Delete);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
